import { UserLoginRo } from './api.generated';

export type SignupHandoffBody = {
  user?: UserLoginRo;
  userKey?: string;
  handoff?: string;
  token?: string;
};

export type HandoffSession = {
  token: string;
  user: UserLoginRo;
};

/**
 * The signup screen spends the single-use code before it continues.
 * A token on the signup body is ignored.
 */
export async function exchangeSignupHandoff(
  signupBody: SignupHandoffBody,
  exchange: (handoff: string) => Promise<HandoffSession>,
): Promise<HandoffSession> {
  const code = signupBody?.handoff?.trim();
  if (!code) {
    throw new Error('Signup did not return a handoff code');
  }
  const session = await exchange(code);
  if (!session?.token || !session.user) {
    throw new Error('Handoff did not return a session');
  }
  return { token: session.token, user: session.user };
}
